module.exports = __webpack_public_path__ + "img/default-browse-vehicles-ford.d86ae1af.png";